import { useState, useEffect } from 'react';
import { isNil } from '../utils/is-nil.js';

/**
 * Executes the passed function the first time the passed variable is initialized (null -> something)
 */
const useInitialization = (fn, variable) => {
  const [hasExecuted, setHasExecuted] = useState(false);
  useEffect(() => {
    if (hasExecuted || isNil(variable)) {
      return;
    }
    setHasExecuted(true);
    fn();
  }, [fn, hasExecuted, variable]);
};

export { useInitialization };
//# sourceMappingURL=use-initialization.js.map
